<template>
  <div v-if="this.title != undefined && this.description != undefined  && this.social" class="text-center">
    <br />
    <p class="p">Share on:</p>
    <a v-for="(network, index) in this.social" :key="index" :class="network" @click="redirectForSocial(network)"
      target="_blank" rel="nofollow" :title="`Share on ${network}`"></a>

    <p class="text-center">Help keep this project going!</p>
    <form action="https://www.paypal.com/donate" method="post" target="_top">
      <input type="hidden" name="business" value="ATZ8MPRBUK5SG" />
      <input type="hidden" name="no_recurring" value="0" />
      <input type="hidden" name="item_name" value="Help keep this project going!" />
      <input type="hidden" name="currency_code" value="USD" />
      <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit"
        title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
      <img alt="" border="0" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
    </form>
  </div>
</template>

<script>
export default {
  name: "Share",
  props: ["title", "description", "social"],
  data() {
    return {
      link: "",
      showAds: false
    };
  },

  mounted() {
    this.currentUrl();
  },

  methods: {
    currentUrl() {
      this.link = window.location.href;
    },

    redirectForSocial(social) {
      let url = "";
      switch (social) {
        case "facebook":
          url = `https://www.facebook.com/sharer/sharer.php?u=${this.link}`;
          break;
        case "twitter":
          url = `http://twitter.com/home?status=Game Rom ${this.title} in: ${this.link}`;
          break;
      }
      window.open(url);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Share.vue